import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import { Container, Spinner } from "reactstrap"
import { useMustRead } from "components/MustRead/MustReadProvider"
import { getStatusMeta, getDisplayStatus, CONTENT_TYPE_META } from "helpers/mustReadStatus"
import {
  PAGE_TITLE,
  PAGE_INTRO,
  ALL_DONE,
  EMPTY_STATE,
  progressText,
  actionLabel,
  versionLabel,
} from "helpers/mustReadCopy"
import "components/MustRead/mustRead.css"

const MustReadPage = () => {
  const { data, loading } = useMustRead()

  useEffect(() => {
    document.title = `${PAGE_TITLE} - ColdBlock Technologies Inc.`
  }, [])

  const items = data?.items || []
  const reviewed = data?.reviewed || 0
  const total = data?.total || 0
  const percent = total ? Math.round((reviewed / total) * 100) : 0
  const allDone = total > 0 && reviewed === total

  return (
    <div className="page-content">
      <Container fluid style={{ maxWidth: 960 }}>
        <h1 className="mr-heading mb-1">{PAGE_TITLE}</h1>
        <p className="mr-intro mb-4">{PAGE_INTRO}</p>

        {loading && !data ? (
          <div className="text-center py-5"><Spinner /></div>
        ) : total === 0 ? (
          <div className="mr-card p-4 text-muted">{EMPTY_STATE}</div>
        ) : (
          <>
            <div className="mr-checklist-header">
              {allDone ? (
                <span className="mr-all-done">
                  <i className="bx bx-check-circle" aria-hidden="true" />
                  {ALL_DONE}
                </span>
              ) : (
                <span className="fw-semibold">{progressText(reviewed, total)}</span>
              )}
              <div
                className="mr-progress"
                style={{ width: 180 }}
                role="progressbar"
                aria-label="Onboarding progress"
                aria-valuemin={0}
                aria-valuemax={100}
                aria-valuenow={percent}
              >
                <div className="mr-progress__bar" style={{ width: `${percent}%` }} />
              </div>
            </div>
            <ul className="mr-list list-unstyled m-0">
              {items.map((item) => {
                const displayStatus = getDisplayStatus(item)
                const meta = getStatusMeta(displayStatus)
                const type = CONTENT_TYPE_META[item.contentType] || CONTENT_TYPE_META.pdf
                const label = actionLabel(item)
                const href = `/must-read/${item.id}${
                  item.status === "in_progress" && item.lastPosition ? `?position=${item.lastPosition}` : ""
                }`
                const version = versionLabel(item.versionNumber, item.publishedAt)
                return (
                  <li key={item.id}>
                    <div className={`mr-row mr-row--${displayStatus}`}>
                      <i className={`bx ${type.icon} mr-row__type`} aria-label={type.label} />
                      <div className="mr-row__body">
                        <p className="mr-row__title">{item.title}</p>
                        {item.description && <p className="mr-row__meta">{item.description}</p>}
                        {version && <p className="mr-row__version">{version}</p>}
                        {displayStatus === "updated" && item.changeNote && (
                          <p className="mr-row__meta">What changed: {item.changeNote}</p>
                        )}
                      </div>
                      <div className="mr-row__aside">
                        <span className={`mr-status ${meta.className}`}>
                          <i className={`bx ${meta.icon}`} aria-hidden="true" />
                          {meta.label}
                        </span>
                        <Link
                          to={href}
                          className="mr-action-btn"
                          aria-label={`${label} ${item.title}`}
                        >
                          {label}
                        </Link>
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          </>
        )}
      </Container>
    </div>
  )
}

export default MustReadPage
